import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  CompanyDto,
  CompanyListDto,
  CompanyFilterDto,
  CreateCompanyRequest,
  UpdateCompanyRequest,
} from '@/types/company.types';

export const companyApi = {
  /** GET /api/v1/companies — paginated list with optional search/filter */
  getList: (filter?: CompanyFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<CompanyListDto>>>('/companies', {
      params: filter,
    }),

  /** GET /api/v1/companies/{id} — full company record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<CompanyDto>>(`/companies/${id}`),

  /** POST /api/v1/companies — create a new company */
  create: (data: CreateCompanyRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/companies', data),

  /** PUT /api/v1/companies/{id} — update company settings */
  update: (id: string, data: UpdateCompanyRequest) =>
    apiClient.put<ApiResponse<object>>(`/companies/${id}`, data),

  /** DELETE /api/v1/companies/{id} — soft-delete (deactivates) the company */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/companies/${id}`),

  /** GET /api/v1/companies/by-code/{code} — returns 404 when not found */
  getByCode: (code: string) =>
    apiClient.get<ApiResponse<CompanyDto>>(`/companies/by-code/${encodeURIComponent(code)}`),

  /** GET /api/v1/companies/code-exists/{code} — quick existence check */
  codeExists: (code: string, excludeId?: string) =>
    apiClient.get<ApiResponse<{ exists: boolean; companyId: string | null }>>(
      `/companies/code-exists/${encodeURIComponent(code)}`,
      { params: excludeId ? { excludeId } : undefined },
    ),
};
